import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";

function Login({ setUser }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // ✅ loading state
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true); // ✅ Start loader

    try {
      const res = await api.post("/login", form);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      setUser(res.data.user);
      navigate("/admin/dashboard");
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message);
      const msg =
        err.response?.data?.message || "Invalid credentials. Please try again.";
      setError(msg);
    } finally {
      setLoading(false); // ✅ Stop loader
    }
  };

  return (
    <div className="relative flex justify-center items-center min-h-screen bg-gradient-to-br from-purple-700 via-purple-400 to-fuchsia-600 overflow-hidden px-4 text-gray-800">
      {/* Animated Background Glow */}
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-gradient-to-br from-fuchsia-400 to-purple-600 rounded-full blur-3xl opacity-25 animate-pulse"></div>
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-gradient-to-tr from-purple-400 to-fuchsia-400 rounded-full blur-3xl opacity-20 animate-pulse"></div>

      {/* Floating Sparkles */}
      {[...Array(70)].map((_, i) => (
        <div
          key={i}
          className="absolute bg-white rounded-full opacity-30"
          style={{
            width: `${Math.random() * 4 + 2}px`,
            height: `${Math.random() * 4 + 2}px`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animation: `float ${3 + Math.random() * 4}s ease-in-out infinite`,
          }}
        ></div>
      ))}

      {/* Main Card */}
      <form
        onSubmit={handleSubmit}
        className="relative bg-white/90 backdrop-blur-2xl p-10 rounded-3xl shadow-2xl border border-purple-200 w-full max-w-md z-10 transform transition-all hover:scale-[1.02] hover:shadow-purple-300/40 duration-300"
      >
        {/* Logo */}
        <div className="flex justify-center mb-6 relative">
          <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-20 h-20 bg-gradient-to-tr from-purple-400 via-fuchsia-400 to-purple-600 rounded-full blur-2xl opacity-60 animate-ping"></div>
          <img
            src="/zarvika/static/media/zarvika_logo.35210c769a3ad7e4d535.png"
            alt="Jeweller Logo"
            className="relative h-16 w-auto drop-shadow-lg"
          />
        </div>

        {/* Title */}
        <h2 className="text-3xl font-serif text-center text-gray-900 mb-2 tracking-wide">
          Jewellers Kitty Login
        </h2>
        <div className="mx-auto mb-4 w-16 h-1 bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full"></div>
        <p className="text-center text-gray-600 mb-6 text-sm italic">
          Manage your jewellery kitties with elegance and trust 💎
        </p>

        {/* Error */}
        {error && (
          <div className="mb-4 p-3 rounded-lg bg-red-50 text-red-600 border border-red-300 text-sm text-center shadow-sm">
            {error}
          </div>
        )}

        {/* Email */}
        <div className="mb-4">
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Email Address
          </label>
          <input
            type="email"
            placeholder="you@example.com"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition duration-200 bg-white/80"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            disabled={loading} required
          />
        </div>

        {/* Password */}
        <div className="mb-6">
          <label className="block text-sm font-semibold text-gray-700 mb-1">
            Password
          </label>
          <input
            type="password"
            placeholder="••••••••"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition duration-200 bg-white/80"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            disabled={loading} required
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className={`w-full flex justify-center items-center gap-2 bg-gradient-to-r from-purple-600 via-fuchsia-600 to-purple-700 text-white py-2.5 rounded-lg font-semibold transition-all duration-200 shadow-md hover:shadow-lg ${
            loading
              ? "opacity-80 cursor-not-allowed hover:shadow-none"
              : "hover:from-purple-700 hover:via-fuchsia-700 hover:to-purple-800"
          }`}
        >
          {loading ? (
            <>
              <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              <span>Signing In...</span>
            </>
          ) : (
            "Sign In"
          )}
        </button>

        {/* Footer */}
        {/* <p className="text-sm text-center text-gray-700 mt-5">
          Don’t have an account?{" "}
          <a
            href="/signup"
            className="text-purple-600 font-medium hover:underline"
          >
            Sign up
          </a>
        </p> */}
      </form>

      {/* Sparkle Animation CSS */}
      <style>{`
        @keyframes float {
          0% { transform: translateY(0px) scale(1); opacity: 0.4; }
          50% { transform: translateY(-20px) scale(1.2); opacity: 0.8; }
          100% { transform: translateY(0px) scale(1); opacity: 0.4; }
        }
      `}</style>
    </div>
  );
}

export default Login;
